import createIcon from '../../createIcon';

/**
 * @component @name WrapText
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDE4SDkuNVYxNkgzLjVWMThaTTE5LjUgNEgzLjVWNkgxOS41VjRaTTE2LjUgMTBIMy41VjEySDE2Ljc1QzE3Ljg1IDEyIDE4Ljc1IDEyLjkgMTguNzUgMTRDMTguNzUgMTUuMSAxNy44NSAxNiAxNi43NSAxNkgxNC41VjE0TDExLjUgMTdMMTQuNSAyMFYxOEgxNi41QzE4LjcxIDE4IDIwLjUgMTYuMjEgMjAuNSAxNEMyMC41IDExLjc5IDE4LjcxIDEwIDE2LjUgMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WrapText = createIcon('WrapText', [
  [
    'path',
    {
      d: 'M3.5 18H9.5V16H3.5V18ZM19.5 4H3.5V6H19.5V4ZM16.5 10H3.5V12H16.75C17.85 12 18.75 12.9 18.75 14C18.75 15.1 17.85 16 16.75 16H14.5V14L11.5 17L14.5 20V18H16.5C18.71 18 20.5 16.21 20.5 14C20.5 11.79 18.71 10 16.5 10Z',
      key: '1u6tl5',
    },
  ],
]);

export default WrapText;
